<template>
  <div>
    <v-card>
      <v-card-title>Usage Details</v-card-title>
      <v-card-text>
        <div class="ck-editor">
          <div class="history-data-parent">
            <span>
              <v-data-table
                :headers="headers"
                :items="data.question.historyDetails"
                class="elevation-1"
                :hide-default-footer="true"
                :mobile-breakpoint="0"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-left fix-101">
                      {{ item.testScheduleDate && item.testBatchName && item.testCenterName? item.testScheduleDate : '-' }}
                    </td>
                    <td class="text-left fix-101">
                      {{ item.testCenterName ? item.testCenterName : 'Not'}}
                    </td>
                    <td class="text-left">{{ item.testBatchName && item.testBatchName.length ? item.testBatchName : 'Scheduled'}}</td>
                  </tr>
                </template>
              </v-data-table>
            </span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "HistoryDetails",
  props: ["data", "onClose"],
  data() {
    return {
      headers: [
        {
          text: "Test Date",
          align: "left",
          value: "date",
          sortable: false,
        },
        { text: "Center", align: "left", value: "center",sortable: false, },
        { text: "Batch", align: "left", value: "batch",sortable: false, },
      ],
    };
  },
  methods: {},
};
</script>
